import { DateTime } from "luxon";
/** America/New_York calendar day — paid auction vehicles before this are excluded from gate-pass needed. */
export const GATE_PASS_NEEDED_CUTOFF_DATE = "2026-07-30";
const GATE_PASS_NEEDED_TIMEZONE = "America/New_York";
const getPaidForCalendarDayEt = (paidForDate) => {
    let paidDt = DateTime.fromISO(String(paidForDate), { setZone: true });
    if (!paidDt.isValid) {
        paidDt = DateTime.fromJSDate(new Date(paidForDate));
    }
    if (!paidDt.isValid)
        return null;
    return paidDt.setZone(GATE_PASS_NEEDED_TIMEZONE).toISODate();
};
const getAuctionLookup = (auctionLocationId, auctionLocationsById) => {
    if (!auctionLocationsById)
        return undefined;
    if (auctionLocationsById instanceof Map) {
        return auctionLocationsById.get(auctionLocationId);
    }
    return auctionLocationsById[auctionLocationId];
};
/**
 * Paid Auction vehicle with no gate_passes, paid on/after GATE_PASS_NEEDED_CUTOFF_DATE (ET).
 * Missing or invalid paid_for_date is treated as not needed (legacy backlog excluded).
 * Auctions with gate_passes_needed === false are excluded when auction_location_id is set
 * and the matching auction is provided in auctionLocationsById.
 */
export const vehicleNeedsGatePass = (vehicle, auctionLocationsById) => {
    if (vehicle.seller_type !== "Auction" || vehicle.paid_for !== true) {
        return false;
    }
    const hasGatePass = Array.isArray(vehicle.gate_passes) && vehicle.gate_passes.length > 0;
    if (hasGatePass)
        return false;
    const auctionLocationId = vehicle.auction_location_id?.trim();
    if (auctionLocationId) {
        const auction = getAuctionLookup(auctionLocationId, auctionLocationsById);
        if (auction && auction.gate_passes_needed === false) {
            return false;
        }
    }
    if (!vehicle.paid_for_date)
        return false;
    const paidDayEt = getPaidForCalendarDayEt(vehicle.paid_for_date);
    return paidDayEt != null && paidDayEt >= GATE_PASS_NEEDED_CUTOFF_DATE;
};
